'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _DocumentModeDebugTool = require('./documentMode/DocumentModeDebugTool');

var _DocumentModeDebugTool2 = _interopRequireDefault(_DocumentModeDebugTool);

require('./DebugToolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = function (props) {
    var perfTool = null;
    // FIXME Required to write the function like this instead of using constants otherwise dead code removal does
    // FIXME not work.  It might be possible to 'teach' webpack the constant though.
    if (process.env.NODE_ENV === 'development') {
        var PerformanceDebugTool = require('./performance/PerformanceDebugTool').default;
        perfTool = _react2.default.createElement(PerformanceDebugTool, props);
    }

    return _react2.default.createElement(
        'div',
        { className: 'DebugToolbar' },
        _react2.default.createElement(
            'div',
            { className: 'debug-toolbar-wrapper' },
            _react2.default.createElement(
                'div',
                { className: 'logo-wrapper' },
                _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-small' }),
                _react2.default.createElement(
                    'span',
                    { className: 'debug-heading' },
                    'Milanote Debug Tools'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'tool-wrapper' },
                _react2.default.createElement(_DocumentModeDebugTool2.default, props),
                perfTool
            )
        )
    );
};

// Styles


// Components


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/DebugToolbar.js
// module id = 1936
// module chunks = 0